import React from 'react';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

import authService from '../../../utilities/AuthService';
import { hideSessionExpiredModal } from '../../../modules/session/redux';

const SessionExpiredModal = (props: any) => {
  const handleConfirm = () => {
    props.onHide();
    authService.onSessionExpired();
  };

  return (
    // Some widgets (e.g. react-select dropdowns) explicitly set zIndex: 9999
    // to render above modals; SweetAlert itself sets no z-index, so wrap it
    // in a stacking context above that to guarantee it's always frontmost.
    <div style={{ position: 'relative', zIndex: 999999 }}>
      <SweetAlert
        warning
        confirmBtnText="Go to Login"
        confirmBtnBsStyle="danger"
        title="Session Expired"
        onConfirm={handleConfirm}
        closeOnClickOutside={false}
        show={props.showExpiredModal}
      >
        Your session has expired, please sign in again.
      </SweetAlert>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  showExpiredModal: state.session.showExpiredModal,
});

const mapDispatchToProps = (dispatch: any) => ({
  onHide: () => dispatch(hideSessionExpiredModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionExpiredModal);
